
import {createSlice} from "@reduxjs/toolkit";

export const dataPointXrefSlice = createSlice({
    name: 'dataPointXrefSlc',
    initialState: {value: {id: 0, dataPointId: null, attributeId: null, ordinalNumber: null,
            xrefStatus: null,
    dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
    attributeCode: null, attributeName: null, category: null, attributeStatus: null,
    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            xrefGridRefresh: false, xrefDrawerState: null, xrefDrawerMode: null,
            dpxListId: 0, dpxListDrawerState: false
        }},
    reducers:
{
    changeDataPointXref: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeDataPointXref } = dataPointXrefSlice.actions;

export default  dataPointXrefSlice.reducer ;
